let apiUrl;
const currentDomain = window.location.hostname;

if (
  currentDomain === "localhost" ||
  currentDomain === "127.0.0.1" ||
  currentDomain.startsWith("192.168.") ||
  currentDomain.startsWith("10.") ||
  currentDomain.startsWith("172.")
) {
  apiUrl = "http://localhost:4000/api";
} else {
  apiUrl = "https://api.chooseyourtherapist.in/api";
}

export const baseApi =
  currentDomain === "localhost" ||
  currentDomain === "127.0.0.1" ||
  currentDomain.startsWith("192.168.") ||
  currentDomain.startsWith("10.") ||
  currentDomain.startsWith("172.")
    ? "http://localhost:4000"
    : "https://api.chooseyourtherapist.in";
export const resumePath = `${baseApi}/uploads/resumes`;
export const imagePath = `${baseApi}/uploads/images`;
export const documentsPath = `${baseApi}/uploads/documents`;
export const loginUrl = `${apiUrl}/login`;
export const getAdminNameByEmailUrl = `${apiUrl}/get-admin-name-by-email`;
export const getTherapists = `${apiUrl}/get-therapists`;
export const therapistStatsUrl = `${apiUrl}/therapist-stats`;
export const profileStatsAdminUrl = `${apiUrl}/admin/profile-stats`;
export const getBookings = `${apiUrl}/get-booking-admin`;
export const cancelBookingUrl = `${apiUrl}/cancel-booking`;
export const deleteBookingUrl = `${apiUrl}/delete-booking`;
export const adminRescheduleUrl = (id) => `${apiUrl}/admin/bookings/${id}/reschedule`;
export const getUsersUrl = `${apiUrl}/get-all-users`;
export const getChatUsersUrl = `${apiUrl}/get-chat-users`;
export const sendBulkUserMailUrl = `${apiUrl}/send-bulk-user-mail`;
export const getEmailLogsUrl = `${apiUrl}/email-logs`;
export const contactMetaUrl  = `${apiUrl}/contact-meta`;
export const sendAproveMail = `${apiUrl}/send-aprove-mail`;
export const aprovedTherapist = `${apiUrl}/aprove-therapist`;
export const therapistVerificationUrl = `${apiUrl}/therapist-verification`; // `/${therapistId}/checklist|reject|reupload`
export const toggleActive = `${apiUrl}/toggle-active`;
export const verifyOtpUrl = `${apiUrl}/verify-otp`;
export const ShowTOPageUrl = `${apiUrl}/toggle-to-show-to-page`;
export const SetPriorityUrl = `${apiUrl}/set-priority`;
export const UpdatePaymentStatusUrl = `${apiUrl}/update-payment-status`;
export const deleteUserUrl = `${apiUrl}/delete-user`;
export const registerUserUrl = `${apiUrl}/register`;
export const createBlogUrl = `${apiUrl}/create-blog`;
export const getBlogsUrl = `${apiUrl}/get-blogs`;
export const updateBlogUrl = `${apiUrl}/update-blog/`; // Backend expects PUT /api/update-blog/:id
export const deleteBlogUrl = `${apiUrl}/delete-blog/`; // ID will be appended
export const deleteReviewUrl = `${apiUrl}/delete-review/`; // ID will be appended
export const sendNotificationUrl = `${apiUrl}/notifications/send-notification`;
export const getReviewsUrl = `${apiUrl}/get-reviews`; 
export const getLeadsUrl = `${apiUrl}/leads`;
export const deleteLeadUrl = `${apiUrl}/leads/`; // ID will be appended
export const updateLeadStatusUrl = `${apiUrl}/leads/`; // `${id}/status` will be appended
export const assignLeadUrl = `${apiUrl}/leads/`; // `${id}/assign` will be appended
export const getLeadActivityUrl = `${apiUrl}/lead-activity`;
export const deleteLeadActivityUrl = `${apiUrl}/lead-activity/`; // ID will be appended
export const getNoidaAppointmentsUrl = `${apiUrl}/noida-appointments`;
export const updateNoidaAppointmentUrl = `${apiUrl}/noida-appointments/`; // ID will be appended
export const assignNoidaAppointmentUrl = `${apiUrl}/noida-appointments/`; // `${id}/assign` will be appended
export const adminBookCreditSessionUrl = `${apiUrl}/noida-appointments/admin-book-credit`;
export const adminCreateNoidaAppointmentUrl = `${apiUrl}/noida-appointments/admin-create`;
export const getNoidaPaymentQrUrl = `${apiUrl}/noida-appointments/payment-qr`;
export const createNoidaOrderUrl = `${apiUrl}/noida-appointments/create-order`;
export const createNoidaAppointmentUrl = `${apiUrl}/noida-appointments`;
export const getNoidaAppointmentLookupUrl = `${apiUrl}/noida-appointments/lookup`;
export const getNoidaFollowupDatesUrl = `${apiUrl}/noida-appointments/followup-dates`;
export const deleteNoidaAppointmentUrl = `${apiUrl}/noida-appointments/`; // ID will be appended
export const getLastMinuteRequestsUrl = `${apiUrl}/noida-appointments/last-minute-requests`;
export const acceptLastMinuteRequestUrl = `${apiUrl}/noida-appointments/last-minute-requests/`; // `${id}/accept` will be appended
export const rejectLastMinuteRequestUrl = `${apiUrl}/noida-appointments/last-minute-requests/`; // `${id}/reject` will be appended
export const getNoidaAppointmentsSummaryUrl = `${apiUrl}/noida-appointments/summary`;
export const exportNoidaAppointmentsUrl = `${apiUrl}/noida-appointments/export`;
export const getNoidaCouponsUrl = `${apiUrl}/noida-coupons`;
export const updateNoidaCouponUrl = `${apiUrl}/noida-coupons/`; // ID will be appended (PATCH / DELETE)
export const validateNoidaCouponUrl = `${apiUrl}/noida-appointments/coupon/validate`;
export const getNoidaPublicTherapistsUrl = `${apiUrl}/noida-appointments/therapists`;
export const getNoidaTherapistOptionsUrl = `${apiUrl}/noida-therapists/options`;
export const updateNoidaTherapistsUrl = `${apiUrl}/noida-therapists`;
export const getPaymentProblemsUrl = `${apiUrl}/noida-appointments/payment-problems`;
export const paymentProblemActionUrl = `${apiUrl}/noida-appointments/payment-problems/`; // `${id}/retry` | `${id}/resolve` will be appended
export const getNoidaClientsUrl = `${apiUrl}/noida-appointments/clients`;
export const getNoidaClientProfileUrl = `${apiUrl}/noida-appointments/client-profile`;
export const deleteNoidaClientUrl = `${apiUrl}/noida-appointments/clients/`; // phone will be appended
export const getNoidaRecentActivityUrl = `${apiUrl}/noida-appointments/recent-activity`;
export const getNoidaPresenceUrl = `${apiUrl}/noida-appointments/presence`;
export const getNoidaCaseNoteUrl = (appointmentId) => `${apiUrl}/noida-case-notes/${appointmentId}`; // GET / PUT handwritten case notes
export const getNoidaCaseHistoryUrl = (appointmentId) => `${apiUrl}/noida-case-notes/history/${appointmentId}`; // the client's notes from other sessions
export const getNoidaExitFeedbackUrl = `${apiUrl}/noida-exit-feedback`;
export const noidaExitFeedbackItemUrl = `${apiUrl}/noida-exit-feedback/`; // ID will be appended (PATCH / DELETE)
export const getFollowupSlotsUrl = `${apiUrl}/noida-followup-slots`;
export const addFollowupSlotsUrl = `${apiUrl}/noida-followup-slots`;
export const deleteFollowupSlotUrl = `${apiUrl}/noida-followup-slots/`; // ID will be appended
export const followupSlotCapacityUrl = (id) => `${apiUrl}/noida-followup-slots/${id}/capacity`;
export const noidaAbandonedUrl = `${apiUrl}/noida-appointments/abandoned`;
export const noidaReviewsAdminUrl = `${apiUrl}/noida-reviews/admin`;
export const noidaReviewUrl = `${apiUrl}/noida-reviews/`; // ID will be appended
export const noidaReviewLinkUrl = (id) => `${apiUrl}/noida-appointments/${id}/review-link`;
export const addFollowupSlotsBulkUrl = `${apiUrl}/noida-followup-slots/bulk`;
export const getNoidaPricingUrl = `${apiUrl}/noida-pricing`;
export const updateNoidaPricingUrl = `${apiUrl}/noida-pricing`;
export const getNoidaPackagesUrl = `${apiUrl}/noida-packages`;
export const createNoidaPackageUrl = `${apiUrl}/noida-packages`;
export const updateNoidaPackageUrl = `${apiUrl}/noida-packages/`; // ID will be appended
export const deleteNoidaPackageUrl = `${apiUrl}/noida-packages/`; // ID will be appended
export const getNoidaClientCreditsUrl = `${apiUrl}/noida-client-credits`;
export const createNoidaClientCreditUrl = `${apiUrl}/noida-client-credits`;
export const updateNoidaClientCreditUrl = `${apiUrl}/noida-client-credits/`; // ID will be appended
export const deleteNoidaClientCreditUrl = `${apiUrl}/noida-client-credits/`; // ID will be appended
export const getNewsletterSubscribersUrl = `${apiUrl}/newsletter-subscribers`;
export const deleteNewsletterSubscriberUrl = `${apiUrl}/newsletter-subscribers/`; // ID will be appended
export const getRolesUrl = `${apiUrl}/roles`;
export const getTeamUrl = `${apiUrl}/team`;
export const getAssignableTeamUrl = `${apiUrl}/team/assignable`;
export const getMyPermissionsUrl = `${apiUrl}/my-permissions`;
export const getResourcesUrl    = `${apiUrl}/resources/all`;
export const uploadResourceUrl  = `${apiUrl}/resources`;
export const deleteResourceUrl  = `${apiUrl}/resources`;
export const sendReminderUrl     = `${apiUrl}/send-reminder`;
export const intakeClientsUrl         = `${apiUrl}/intake-clients`;
export const receptionClientsUrl      = `${apiUrl}/reception-clients`;
export const receptionPricesUrl       = `${apiUrl}/reception-plan-prices`;
export const appointmentRequestsUrl   = `${apiUrl}/appointment-requests`;
export const sendCertificateEmailUrl  = `${apiUrl}/certificate/send-email`;
export const certificatesUrl          = `${apiUrl}/admin/certificates`; // + /:id, /import
export const getProbonoInternsUrl    = `${apiUrl}/probono-interns/all`;
export const createProbonoInternUrl  = `${apiUrl}/probono-interns`;
export const updateProbonoInternUrl  = `${apiUrl}/probono-interns`;
export const deleteProbonoInternUrl  = `${apiUrl}/probono-interns`;
export const getProbonoReviewsUrl    = `${apiUrl}/probono-reviews`;
export const deleteProbonoReviewUrl  = `${apiUrl}/probono-reviews`;
export const getProbonoLeadsUrl      = `${apiUrl}/probono-leads`;
export const getProbonoFunnelUrl     = `${apiUrl}/admin/probono/funnel`;
export const probonoSessionsUrl      = `${apiUrl}/admin/probono/sessions`;
export const getTraineesUrl          = `${apiUrl}/admin/trainees`;
export const updateTraineeStatusUrl  = `${apiUrl}/admin/trainees`; // + /:id/status
export const deleteTraineeUrl        = `${apiUrl}/admin/trainees`; // + /:id
export const traineeAccountsUrl     = `${apiUrl}/admin/trainee-accounts`; // + /:id (PATCH approval)
export const activityFeedUrl        = `${apiUrl}/admin/activity-feed`;
export const overviewSummaryUrl     = `${apiUrl}/admin/overview-summary`;
export const reassignBookingUrl     = (id) => `${apiUrl}/admin/bookings/${id}/reassign`; // Client 360 → Replace therapist
export const aiVisitsUrl            = `${apiUrl}/admin/ai-visits`; // visitors from ChatGPT, Perplexity, Gemini …
export const sessionPacksUrl        = `${apiUrl}/admin/session-packs`; // + /:id/extend
export const packPricingUrl         = `${apiUrl}/admin/pack-pricing`; // GET, PUT (super admin): sizes, % off, validity
export const festivalOffersUrl      = `${apiUrl}/admin/festival-offers`; // GET (+ ?offer=), PUT /:key — festival 1+1 switches, buyers & gift links
export const adminTodoUrl           = `${apiUrl}/admin/todo`; // everything waiting on the team (Home / To-do)
export const adminSearchUrl         = `${apiUrl}/admin/search`; // Ctrl+K: clients, therapists, booking id
export const clientGrowthUrl        = `${apiUrl}/admin/client-growth`; // client portal: rebook / review / referral / recovered payments
export const client360Url           = `${apiUrl}/admin/client-360`; // + /:id
export const traineePortalUrl       = `${apiUrl}/admin/trainee-portal`; // + /people /attendance /tasks /notes /certificates

export const sessionReportsUrl       = `${apiUrl}/session-reports`; // + /:id
export const quotationsUrl           = `${apiUrl}/quotations`; // + /:id, /:id/pdf, /:id/status
export const googleReviewsUrl      = `${apiUrl}/google-reviews`;
export const offerLettersUrl         = `${apiUrl}/offer-letters`; // + /:id, /:id/pdf, /:id/status, /:id/send

/* Staff system: attendance, tasks, notices, performance (see backend routes/staff.js) */
export const staffStreamUrl       = `${apiUrl}/staff/stream`;
export const staffMeUrl           = `${apiUrl}/staff/me`;
export const staffCheckInUrl      = `${apiUrl}/staff/check-in`;
export const staffCheckOutUrl     = `${apiUrl}/staff/check-out`;
export const staffTasksUrl        = `${apiUrl}/staff/tasks`;       // + /:id, /:id/status
export const staffNoticesUrl      = `${apiUrl}/staff/notices`;     // + /:id, /:id/read
export const staffTeamUrl         = `${apiUrl}/staff/team`;
export const staffAttendanceUrl   = `${apiUrl}/staff/attendance`;
export const staffSettingsUrl     = `${apiUrl}/staff/settings`;
export const staffTargetsUrl      = `${apiUrl}/staff/targets`;
export const staffPerformanceUrl  = `${apiUrl}/staff/performance`;
export const staffLeavesUrl       = `${apiUrl}/staff/leaves`;      // + /:id
export const staffWfhUrl          = `${apiUrl}/staff/wfh`;         // + /:id

// Collaborations: professionals applying to practise at CYT Noida + the single room's timetable
export const collabApplicationsUrl = `${apiUrl}/collab-applications`;
export const collabApplicationUrl = (id) => `${apiUrl}/collab-applications/${id}`;
export const collabRoomUrl = `${apiUrl}/collab-room`;
export const collabRoomSlotUrl = `${apiUrl}/collab-room/slot`;
export const collabSendHoursUrl = (id) => `${apiUrl}/collab-applications/${id}/send-hours`;

// Therapist listing subscriptions (who paid, plan, expiry)
export const therapistSubscriptionsUrl = `${apiUrl}/admin/therapist-subscriptions`;
export const assessmentPricingUrl = `${apiUrl}/admin/assessment-pricing`;
export const assessmentAddonsUrl = `${apiUrl}/admin/assessment-addons`;
export const assessmentAddonActionUrl = (userId) => `${apiUrl}/admin/assessment-addons/${userId}`;
// therapist "Coupons" upgrade (one-time): list + price, unlock free / turn off, set price (Super Admin)
export const couponsAddonUrl = `${apiUrl}/coupon/admin/addon`;
export const couponsAddonActionUrl = (userId) => `${apiUrl}/coupon/admin/addon/${userId}`;
export const couponsAddonPriceUrl = `${apiUrl}/coupon/admin/addon-price`;
// Outreach Email (designed collaboration emails): presets, preview, send, history
export const outreachUrl = `${apiUrl}/outreach`;
export const therapistSubscriptionPaymentsUrl = (userId) => `${apiUrl}/admin/therapist-subscriptions/${userId}/payments`;
export const therapistSubscriptionRemindUrl = (userId) => `${apiUrl}/admin/therapist-subscriptions/${userId}/remind`;
export const therapistSubscriptionFreeUrl = (userId) => `${apiUrl}/admin/therapist-subscriptions/${userId}/free`;
export const therapistReminderTemplatesUrl = `${apiUrl}/admin/therapist-subscriptions/reminder-templates`;

// therapist ↔ CYT team (announcements, requests, payouts, messages)
export const commsSummaryUrl        = `${apiUrl}/admin/therapist-comms/summary`;
export const commsTherapistsUrl     = `${apiUrl}/admin/therapist-comms/therapists`;
export const commsAnnouncementsUrl  = `${apiUrl}/admin/therapist-comms/announcements`;
export const commsActionsUrl        = `${apiUrl}/admin/therapist-comms/actions`;
export const commsPayoutsUrl        = `${apiUrl}/admin/therapist-comms/payouts`;
export const commsPayoutBookingsUrl = `${apiUrl}/admin/therapist-comms/payout-bookings`;
export const commsFeedbackUrl       = `${apiUrl}/admin/therapist-comms/feedback`;
